import { Card, CardContent, Stack, Link, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ACCOUNT_DETAILS_PAGE_URL } from "@constants";
import { useStyle } from "./style";
import { useDeviceType } from "@hook/useDeviceType";

export const CancelBroadbandError = () => {
    const { t } = useTranslation("cancelBroadband");
    const { push } = useHistory();
    const { isMobile } = useDeviceType();
    const { classes } = useStyle(isMobile);

    return (
        <Card elevation={0}>
            <CardContent className={classes.cardContent}>
                <div className={classes.leftBox}>
                    <InfoIcon color="secondary" />
                    <Stack spacing={1}>
                        <Typography color="secondary" fontWeight="bold" variant="large">
                            {t("error.title")}
                        </Typography>
                        <Typography color="secondary" variant="normal">
                            {t("error.description")}
                        </Typography>
                    </Stack>
                </div>
                <Link className={classes.link} onClick={() => push(ACCOUNT_DETAILS_PAGE_URL)}>
                    <Stack alignItems="center" direction="row" spacing={1}>
                        <ArrowForwardRoundedIcon fontSize="small" />
                        <Typography color="primary" variant="small">
                            {t("error.backToAccountDetails")}
                        </Typography>
                    </Stack>
                </Link>
            </CardContent>
        </Card>
    );
};
